module.exports = __webpack_public_path__ + "static/img/app-manage.7d0615a7.png";